import { ReactNode } from "react"

export default function BlobLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <img
        src="/404/leftBubbleBlob.png"
        alt="leftBlob"
        className="fixed left-0 top-1/2 hidden h-[66dvh] w-[25dvw] -translate-y-[180px] lg:block"
      />

      <img
        src="/404/Circle.png"
        alt="topLeftCircle"
        className="fixed left-0 top-0 hidden h-[10dvh] w-[5dvw] translate-x-16 translate-y-16 lg:block"
      />

      <img
        src="/404/Circle.png"
        alt="bottomLeftCircle"
        className="fixed bottom-0 left-0 hidden h-[6dvh] w-[3dvw] -translate-y-36 translate-x-[360px] lg:block"
      />

      <img
        src="/404/Circle.png"
        alt="middleRightCircle"
        className="fixed right-0 top-1/2 hidden h-[6dvh] w-[3dvw] -translate-x-1/2 -translate-y-1/2 lg:block"
      />

      <img
        src="/404/topRightBlob.png"
        alt="topRightBlob"
        className="fixed right-0 top-0 hidden h-[70dvh] w-[45dvw] -translate-y-[180px] lg:block"
      />

      <img
        src="/404/bottomRightBlob.png"
        alt="bottomRightBlob"
        className="fixed bottom-0 right-0 z-0 hidden h-[300px] w-[300px] -translate-x-14 -translate-y-12 lg:block"
      />

      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center justify-center space-y-4">
          {children}
        </div>
      </div>
    </>
  )
}
